import Privacy from "../components/privacy";
import LowCosts from "../components/lowcosts";
import Trust from "../components/trust";
import Cooperation from "../components/cooperation";
import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scrollToTop";

const HomePage = () => {
  return (
    <>
      <div className="page-container">
        <section className="hero-section">
          <img
            src="https://d3ca8k3fzbwwwf.cloudfront.net/homeHero.webp"
            alt="home hero img"
          />
          <div className="green-tint"></div>
          <div className="home-hero-content-container">
            <h1>away home zone</h1>
            <span>Giving you a home away from home</span>
            <div className="buttons-container">
              <Link to="/about" onClick={scrollToTop}>
                <button className="alt-button">Learn more about us</button>
              </Link>

              <Link to="/contact" onClick={scrollToTop}>
                <button>Contact us</button>
              </Link>
            </div>
          </div>
        </section>
        <section className="percs-section">
          <div className="content-container">
            <div className="perc">
              <div className="icon-and-title">
                <Privacy />
                <h3>privacy</h3>
              </div>
              <div className="text">
                <p>
                  We provide private, peaceful and comfortable accommodation
                  that make our guests feel at home while away.
                </p>
              </div>
            </div>
            <div className="perc">
              <div className="icon-and-title">
                <LowCosts />
                <h3>low costs</h3>
              </div>
              <div className="text">
                <p>
                  Our charges are lower than conventional hotels without
                  compromising on quality, cleanliness or location convenience.
                </p>
              </div>
            </div>
            <div className="perc">
              <div className="icon-and-title">
                <Trust />
                <h3>trust</h3>
              </div>
              <div className="text">
                <p>
                  We offer peace of mind to the Landlords by eliminating rent
                  voids, taking good care of their properties, and entirely
                  removing the stress of chasing tenants for rent.
                </p>
              </div>
            </div>
            <div className="perc">
              <div className="icon-and-title">
                <Cooperation />
                <h3>Cooperation</h3>
              </div>
              <div className="text">
                <p>
                  The estate Agents are not left behind. We ensure that those
                  who partner with us receive their commissions when due.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="what-we-do">
          <div className="section-header-line">
            <h2>What we do</h2>
            <hr />
          </div>
          <div className="content-container">
            <div className="text-container">
              <p>
                We acquire suitable properties that meet the needs of our
                clients from the Landlords/estate Agents. After furnishing and
                ensuring that the properties meet the high standard expected of
                us, they are subsequently offered to our guests on short-term
                basis. In addition, we render management services, advise on
                property matters and also partner with other investors on joint
                ventures.
              </p>
              <Link to="/about" onClick={scrollToTop}>
                <button>Learn more</button>
              </Link>
            </div>
            <div className="img-container">
              <img
                src="https://d3ca8k3fzbwwwf.cloudfront.net/whatWeDo.webp"
                alt="what we do"
              />
            </div>
          </div>
        </section>
        <section className="make-an-inquiry" id="make-an-inquiry">
          <div className="section-header-line">
            <h2>make an enquiry</h2>

            <hr />
          </div>{" "}
          <div className="content-container">
            {" "}
            <div className="images-container">
              <div className="img-container kitchen">
                <img
                  src="https://d3ca8k3fzbwwwf.cloudfront.net/inquiryKitchen.webp"
                  alt="make an enquiry"
                />
              </div>
              <div className="img-container">
                <img
                  src="https://d3ca8k3fzbwwwf.cloudfront.net/inquiryBed.webp"
                  alt="make an enquiry"
                />
              </div>
              <div className="img-container">
                <img
                  src="https://d3ca8k3fzbwwwf.cloudfront.net/inquiryBath.webp"
                  alt="make an inquiry"
                />
              </div>
            </div>
            <div className="text-container">
              <p>
                Are you a landlord, tired of increased regulatory pressures and
                legal compliances? Are you experiencing difficulties and costs
                trying to evict bad tenants? Are you frustrated with tenants not
                paying their rents regularly and on time, or increased
                maintenance costs and poor handling of your properties? Do you
                have difficulties finding reliable tenants that take good care
                of the properties, and abide by the rental terms? Contact us, we
                have the solution for you.
              </p>

              <Link to="/contact" onClick={scrollToTop}>
                <button>Contact us</button>
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default HomePage;
